exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host .container {\n  padding-top: 70px; }\n\n:host h1 {\n  margin-top: 10px;\n  margin-bottom: 20px; }\n\n:host .breadcrumb {\n  background-color: transparent;\n  margin-bottom: 0;\n  margin-top: 10px; }\n\n:host .delete-event {\n  margin-top: 10px; }\n\n:host form {\n  width: 40%; }\n  :host form .form-group {\n    margin-bottom: 20px; }\n    :host form .form-group a {\n      text-decoration: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/components/event/event-edition/event-edition.component.scss
// module id = 177
// module chunks = 0